import { useTenant } from '@providers/Tenant';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { instructionQueryKeys } from '../../shared/api/queryKeys';
import { VersionsService } from '../api/versionsService';

export function useListInstructionVersions(instructionId?: string) {
  const { accountId } = useTenant();
  const service = useMemo(() => new VersionsService(), []);

  const {
    data,
    hasNextPage: hasMore,
    fetchNextPage: fetchMore,
    ...rest
  } = useInfiniteQuery({
    queryKey: [instructionQueryKeys.listInstructionVersions, instructionId],
    queryFn: ({ pageParam: nextToken }) => service.list(accountId, instructionId!, { nextToken }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    enabled: instructionId != null,
    refetchInterval(data) {
      if (data?.pages) {
        // Check for versions which are in the process of duplicating
        const hasDuplicatingVersions = data.pages
          .flatMap((page) => page.items)
          .some((version) => version.status === 'duplicating');

        if (hasDuplicatingVersions) {
          return 1000 * 10; // Check again in 10 seconds
        }
      }
      return false;
    },
  });

  return { data: data?.pages?.flatMap(({ items }) => items), hasMore, fetchMore, ...rest };
}
